import React from 'react';

const QUESTIONS = [
  {
    q: '1',
    label: '1. What kind of day are you after?',
    options: [
      { val: 'lively', icon: 'music', text: 'Lively — music, people, energy' },
      { val: 'quiet', icon: 'umbrella-beach', text: 'Quiet — relax and unwind' },
      { val: 'mix', icon: 'balance-scale', text: 'Somewhere in between' },
      { val: 'surprise', icon: 'dice', text: "Surprise me — I'm open to anything" },
    ],
  },
  {
    q: '2',
    label: '2. How important is having food and drinks available on the island?',
    options: [
      { val: 'essential', icon: 'utensils', text: 'Essential — we want to eat out' },
      { val: 'nice', icon: 'thumbs-up', text: 'Nice to have, not a must' },
      { val: 'byo', icon: 'shopping-basket', text: "We're bringing everything ourselves" },
      { val: 'unsure', icon: 'question-circle', text: 'Not sure yet' },
    ],
  },
  {
    q: '3',
    label: '3. How are you getting to the ferry terminal?',
    options: [
      { val: 'car', icon: 'car', text: 'Driving & parking at the terminal' },
      { val: 'lirr', icon: 'train', text: 'Taking the LIRR' },
      { val: 'dropoff', icon: 'taxi', text: 'Getting dropped off / rideshare' },
      { val: 'unsure', icon: 'question-circle', text: 'Not sure yet' },
    ],
  },
];

const TiebreakerStep = ({ topMatches, answers, onPick, onBack, onResult }) => {
  const pills = topMatches.filter((d) => d !== '__surprise__').slice(0, 3);
  const done = ['1', '2', '3'].every((q) => answers[q]);
  return (
    <div>
      <div className="step-eyebrow">Step 2 of 3</div>
      <div className="step-title">Just a couple more quick questions</div>
      <div className="step-subtitle">
        Based on your picks, you're a great match for:
      </div>
      {pills.length > 0 && (
        <div className="match-pills">
          {pills.map((d) => (
            <div className="pill" key={d}>
              {d}
            </div>
          ))}
        </div>
      )}
      <div className="divider" />
      {QUESTIONS.map((block) => (
        <div className="q-block" key={block.q}>
          <div className="q-label">{block.label}</div>
          <div className="options-grid">
            {block.options.map((o) => (
              <button
                type="button"
                key={o.val}
                className={`option-btn${answers[block.q] === o.val ? ' selected' : ''}`}
                onClick={() => onPick(block.q, o.val)}
              >
                <i className={`far fa-${o.icon} option-icon`} />
                {o.text}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="quiz-footer">
        <button type="button" className="back-btn" onClick={onBack}>
          ← Back
        </button>
        <button
          type="button"
          className={`next-btn${done ? ' active' : ''}`}
          disabled={!done}
          onClick={onResult}
        >
          Show my recommendation →
        </button>
      </div>
    </div>
  );
};

export default TiebreakerStep;
